import * as React from "react";
import { LineSegment, VictoryAxis, VictoryBar, VictoryChart, VictoryContainer, VictoryStack } from "victory";

export interface Datum {
  x: number | string;
  y: number;
}
export interface StackedBarGraphData {
  ticks: string[];
  segments: Datum[][];
  colors: string[];
  tickCount?: number;
}

interface Props {
  data: StackedBarGraphData;
  height?: number;
  width?: number;
  showingTimeOfDay?: boolean;
}
export class StackedBarGraph extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }
  renderStacks(data: StackedBarGraphData) {
    if (!data || !data.segments) {
      return;
    }
    const filteredSegments = data.segments.filter((segment, index) => {
      const isValid = segment?.length > 0 && segment[0]?.x !== undefined && segment[0]?.y !== undefined;
      return isValid;
    });

    return filteredSegments.map((segment, index) => {
      return <VictoryBar data={segment} key={`segment-${index}-${segment[0]?.x}`} />;
    });
  }

  render() {
    const { data, showingTimeOfDay } = this.props;

    const strokeDasharray = "10, 5";
    const strokeLinecap = "round";
    const strokeLinejoin = "round";

    const height = this.props.height ? this.props.height : 260;
    const width = this.props.width ? this.props.width : 600;
    const tickCount = data.tickCount ? data.tickCount : 5;
    return (
      <div className={"StackedBarGraph"}>
        <VictoryChart
          height={height}
          width={width}
          containerComponent={<VictoryContainer responsive={false} />}
          padding={{ top: 9, bottom: 40, left: 40, right: 20 }}
          //    theme={VictoryTheme.material}

          domainPadding={{ x: 30, y: 0 }}
        >
          <VictoryAxis
            dependentAxis
            style={{
              axis: { stroke: "none" },
              axisLabel: { fill: "#C3BCB9", color: "#C3BCB9", fontSize: 40, padding: 0 },
              grid: {
                stroke: "#C3BCB9",
                strokeDasharray,
                strokeLinecap,
                strokeLinejoin
              },
              tickLabels: { fontSize: 15, fill: "#C3BCB9", padding: 10 }
            }}
            tickFormat={(tick) => `${tick}`}
            gridComponent={<LineSegment />}
          />
          <VictoryAxis
            // tickFormat={data.ticks}
            tickCount={tickCount}
            style={{
              axis: { stroke: "none" },
              tickLabels: { fontSize: 15, fill: "#C3BCB9", padding: 10 }
            }}
            tickFormat={(t) => {
              if (t && typeof t === "string" && showingTimeOfDay) {
                const split = t.split(":");
                if (split[0] == "00") {
                  return "12:" + split[1];
                }
                if (parseInt(split[0]) > 12) {
                  return parseInt(split[0]) - 12 + ":" + split[1];
                }
                // if (t === HourOfDay.HOUR_00_00) { return "12:00"}
                // if (t === HourOfDay.HOUR_03_00) { return "3:00"}
                // if (t === HourOfDay.HOUR_06_00) { return "6:00"}
                // if (t === HourOfDay.HOUR_09_00) { return "9:00"}
                // if (t === HourOfDay.HOUR_12_00) { return "Noon"}
                // if (t === HourOfDay.HOUR_15_00) { return "3:00"}
                // if (t === HourOfDay.HOUR_18_00) { return "6:00"}
                // if (t === HourOfDay.HOUR_21_00) { return "9:00"}
                // if (t === HourOfDay.HOUR_23_00) { return "11:00"}

                // return ""
              }

              return t;
            }}
          />

          <VictoryStack colorScale={data.colors}>
            {this.renderStacks(data)}
            {/* <VictoryBar
    data={[1,3,6,4,5,6]}
  />
  <VictoryBar

    data={[1,3,6,4,5,6,6,7]}
*/}
          </VictoryStack>
        </VictoryChart>
      </div>
    );
  }
}
